// extracted by mini-css-extract-plugin
module.exports = {"label-status":"OrganizationDetail_label-status__2nPdl","switch_status":"OrganizationDetail_switch_status__1T67N"};